// extracted by mini-css-extract-plugin
export default {"labelDefault":"Label_labelDefault__Zy2Sh","text":"Label_text__EWhq7","labelRequired":"Label_labelRequired__cppzj","text1":"Label_text1__C0wd1"};